module.exports = __webpack_public_path__ + "static/media/confirmation.0f297f40.jpg";